/**
 * AngularJS `$q` unhandled-rejection strings, classified for RUM reporting.
 *
 * `$q` hands `$exceptionHandler` a plain string with the rejection as JSON behind a fixed prefix, so the value never arrives as an object.
 */

import { classifyHttpRejection, type HttpRejection, type RejectionVerdict } from './httpRejections';

const UNHANDLED_REJECTION_PREFIX = /^Possibly unhandled rejection:\s*/;

/** Classifies a value AngularJS's `$exceptionHandler` reported for an unhandled `$q` rejection. */
export function classifyAngularRejection(error: unknown): RejectionVerdict {
  return classifyHttpRejection(parseRejectionString(error));
}

// The prefix is evidence of a `$q` rejection, so any parseable payload goes on to classification.
// Only an `$http` response at the reportable status is reported.
// Any other payload is the app's own control flow.
function parseRejectionString(error: unknown): HttpRejection | null {
  if (typeof error !== 'string' || !UNHANDLED_REJECTION_PREFIX.test(error)) return null;

  try {
    const parsed: unknown = JSON.parse(error.replace(UNHANDLED_REJECTION_PREFIX, ''));
    return parsed ? parsed as HttpRejection : null;
  } catch (_error) {
    return null;
  }
}
